/**
 * @generated SignedSource<<fea43931784d6c2ea839a45f16fefb2d>>
 * @relayHash 1a55ed09cd9e406af588ec3641dc1db3
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1a55ed09cd9e406af588ec3641dc1db3

import { ConcreteRequest } from 'relay-runtime';
export type EndVideoCallInput = {
  roomSid: string;
};
export type useEndVideoCallMutation$variables = {
  input: EndVideoCallInput;
};
export type useEndVideoCallMutation$data = {
  readonly endVideoCall: {
    readonly endVideoCallOutput: {
      readonly isSuccessful: boolean;
      readonly roomSid: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly roomSid?: string;
    }> | null;
  };
};
export type useEndVideoCallMutation = {
  response: useEndVideoCallMutation$data;
  variables: useEndVideoCallMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roomSid",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "EndVideoCallOutput",
  "kind": "LinkedField",
  "name": "endVideoCallOutput",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuccessful",
      "storageKey": null
    },
    (v2/*:: as any*/)
  ],
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    (v2/*:: as any*/)
  ],
  "type": "CannotFindAvailableVideoCallRoom",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useEndVideoCallMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "EndVideoCallPayload",
        "kind": "LinkedField",
        "name": "endVideoCall",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useEndVideoCallMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "EndVideoCallPayload",
        "kind": "LinkedField",
        "name": "endVideoCall",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "1a55ed09cd9e406af588ec3641dc1db3",
    "metadata": {},
    "name": "useEndVideoCallMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "31b19f688191045ba095f57fcca7cfba";

export default node;
